import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.push.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 接口api
import { recouseList, groupList, groupInfo, modifyGroup, createGroup, remove } from 'api/settings';
var formData = function formData() {
  return {
    id: '',
    group_name: '',
    grant: []
  };
};
var listCheckArr = function listCheckArr(_this) {
  return [{
    inde: false,
    is_can_setting: false,
    privilege_key: 'view',
    privilege_name: _this.$t('64'),
    data: {},
    tips: null,
    value: false
  }, {
    inde: false,
    is_can_setting: false,
    privilege_key: 'edit',
    privilege_name: _this.$t('71'),
    data: {},
    tips: null,
    value: false
  }, {
    inde: false,
    is_can_setting: false,
    privilege_key: 'delete',
    privilege_name: _this.$t('65'),
    data: {},
    tips: null,
    value: false
  }, {
    inde: false,
    is_can_setting: false,
    privilege_key: 'export',
    privilege_name: _this.$t('68'),
    data: {},
    tips: null,
    value: false
  }, {
    inde: false,
    is_can_setting: false,
    privilege_key: 'setting',
    privilege_name: _this.$t('63'),
    data: {},
    tips: null,
    value: false
  }];
};
var allSelect = function allSelect(_this) {
  return {
    inde: false,
    value: false,
    label: _this.$t('21'),
    viewLen: 0,
    editLen: 0,
    deleteLen: 0,
    exportLen: 0,
    settingLen: 0
  };
};
export default {
  data: function data() {
    return {
      type: this.$route.query.type ? Number(this.$route.query.type) : null,
      groupOptions: [],
      recouseList: [],
      listCheckArr: listCheckArr(this),
      formData: formData(),
      allSelect: allSelect(this),
      rules: {
        id: [{
          required: true,
          message: this.$t('820'),
          trigger: ['change']
        }],
        group_name: [{
          required: true,
          message: this.$t('820'),
          trigger: ['blur']
        }]
      }
    };
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _this2.getRecouseList();
          case 2:
            if (!_this2.type) {
              _context.next = 5;
              break;
            }
            _context.next = 5;
            return _this2.groupGetList();
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    setStatus: function setStatus(val) {
      if (val.ever) {
        val.item.value = true;
        val.item.inde = false;
      } else if (val.some) {
        val.item.value = false;
        val.item.inde = true;
      } else {
        val.item.inde = false;
        val.item.value = false;
      }
    },
    handleItem: function handleItem(extend, extendIndex, sub, subIndex, parent) {
      this.handleItemStatus(sub);
      this.handleParentStatus(parent);
      this.handleRowStatus();
      this.handleAllStatus();
    },
    handleSub: function handleSub(sub, subIndex, parent) {
      if (sub.isSelect.inde) {
        sub.isSelect.inde = false;
        sub.isSelect.value = true;
      }
      sub.extend_privilege.forEach(function (extend) {
        if (extend.is_can_setting) {
          extend.value = sub.isSelect.value;
        }
      });
      this.handleParentStatus(parent);
      this.handleRowStatus();
      this.handleAllStatus();
    },
    handleParent: function handleParent(parent) {
      if (parent.isSelect.inde) {
        parent.isSelect.inde = false;
        parent.isSelect.value = true;
      }
      if (parent.children && parent.children.length) {
        parent.children.forEach(function (sub, subIndex) {
          sub.isSelect.inde = false;
          sub.isSelect.value = parent.isSelect.value;
          sub.extend_privilege.forEach(function (extend) {
            if (extend.is_can_setting) {
              extend.value = sub.isSelect.value;
            }
          });
        });
      }
      this.handleRowStatus();
      this.handleAllStatus();
    },
    // item状态
    handleItemStatus: function handleItemStatus(sub) {
      // 没有需要设置的项 直接返回
      if (sub.is_extend) {
        return;
      }
      // 子元素全选状态
      var subEvery = sub.extend_privilege.filter(function (item) {
        if (item.is_can_setting) return item.value;
      });
      var subSome = sub.extend_privilege.some(function (item) {
        if (item.is_can_setting) return item.value;
      });
      this.setStatus({
        ever: subEvery.length && subEvery.length === sub.extendLen,
        some: subSome,
        item: sub.isSelect
      });
    },
    // 父元素全选状态
    handleParentStatus: function handleParentStatus(parent) {
      var parentEvery = parent.children.every(function (child) {
        return child.isSelect.value;
      });
      var parentSome = parent.children.some(function (child) {
        return child.isSelect.value || child.isSelect.inde;
      });
      this.setStatus({
        ever: parentEvery,
        some: parentSome,
        item: parent.isSelect
      });
    },
    // 列全选状态
    handleRowStatus: function handleRowStatus() {
      var _this3 = this;
      console.log(this.listCheckArr);
      this.listCheckArr.forEach(function (item) {
        var keys = Object.keys(item.data);
        var some = keys.some(function (key) {
          return item.data[key].value;
        });
        var ever = keys.every(function (key) {
          return item.data[key].value;
        });
        _this3.setStatus({
          ever: ever,
          some: some,
          item: item
        });
      });
    },
    // 所有全选状态
    handleAllStatus: function handleAllStatus() {
      var allSome = this.recouseList.some(function (item) {
        return item.isSelect.value || item.isSelect.inde;
      });
      var alleEvery = this.recouseList.every(function (item) {
        return item.isSelect.value;
      });
      this.setStatus({
        ever: alleEvery,
        some: allSome,
        item: this.allSelect
      });
    },
    handleColumnStatus: function handleColumnStatus(extend, index) {
      var _this4 = this;
      this.recouseList.forEach(function (parent) {
        parent.children.forEach(function (sub) {
          var item = sub.extend_privilege[index];
          if (item.is_can_setting) {
            item.value = extend.value;
          } else {}
          _this4.handleItemStatus(sub);
        });
        _this4.handleParentStatus(parent);
      });
      this.handleAllStatus();
    },
    // 点击列的全选
    handleColumn: function handleColumn(extend, index) {
      var _this5 = this;
      if (extend.inde) {
        this.$confirm(this.$t('ask-select-all'), this.$t('229'), {
          confirmButtonText: this.$t('131'),
          cancelButtonText: this.$t('66'),
          type: 'warning'
        }).then(function () {
          extend.value = true;
          extend.inde = false;
          _this5.handleColumnStatus(extend, index);
        }).catch(function () {});
      } else {
        this.handleColumnStatus(extend, index);
      }
    },
    handleAllSelect: function handleAllSelect() {
      var _this6 = this;
      if (this.allSelect.inde) {
        this.allSelect.value = true;
        this.allSelect.inde = false;
      }
      this.listCheckArr.forEach(function (item) {
        item.value = _this6.allSelect.value;
        item.inde = false;
      });
      this.handleData(this.recouseList, 'all');
    },
    handleData: function handleData(data, type) {
      var _this7 = this;
      var list = [];
      if (!type) this.allSelect = allSelect(this);
      data.forEach(function (item) {
        item.isSelect = {
          label: _this7.$t('21'),
          inde: false,
          value: _this7.allSelect.value
        };
        item.type = item.id;
        item.open = true;
        list.push(item);
        item.children.forEach(function (child) {
          child.isSelect = {
            label: _this7.$t('21'),
            inde: false,
            value: _this7.allSelect.value
          };
          child.extend = {};
          if (!child.extend_privilege.length) {
            child.extend_privilege = listCheckArr(_this7);
            child.is_extend = true;
          }
          child.extend_privilege.forEach(function (extend, index) {
            var checkItem = _this7.listCheckArr[index] || {};
            extend.inde = false;
            extend.value = _this7.allSelect.value;
            if (extend.is_can_setting) {
              checkItem.data[child.id] = extend;
              // 设置每个类型的个数
              _this7.allSelect[extend.privilege_key + 'Len'] += 1;
              child.extend[extend.privilege_key] = extend;
            }
          });
          var extend = child.extend_privilege.filter(function (extend) {
            return extend.is_can_setting;
          });
          child.paren_id = item.id;
          child.type = item.id + '_' + child.id;
          child.extendLen = extend.length;
          list.push(child);
        });
      });
      this.recouseList = data;
    },
    handleCreate: function handleCreate() {
      var _this8 = this;
      // 权限数组
      var api = createGroup;
      var query = {
        group_name: this.formData.group_name,
        grant: []
      };
      this.recouseList.forEach(function (parent) {
        parent.children.forEach(function (item) {
          if (item.isSelect.inde || item.isSelect.value) {
            var obj = {
              resource_id: item.id,
              view: false,
              edit: false,
              delete: false,
              export: false,
              setting: false
            };
            item.extend_privilege.forEach(function (extend) {
              if (extend.privilege_key) obj[extend.privilege_key] = extend.value || false;
            });
            query.grant.push(obj);
          }
        });
      });
      if (this.type) {
        api = modifyGroup;
        query = {
          grant: query.grant,
          group_id: this.formData.id
        };
      }
      this.$refs.formData.validate(function (valid) {
        if (valid) {
          api(query).then(function () {
            _this8.$message.success(_this8.$t('818'));
            _this8.handlerBack();
          });
        }
      });
    },
    // 获取权限资源列表
    getRecouseList: function getRecouseList() {
      var _this9 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _yield$recouseList, data;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return recouseList();
            case 2:
              _yield$recouseList = _context2.sent;
              data = _yield$recouseList.data;
              _this9.handleData(data);
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    // 获取组数据
    groupGetList: function groupGetList() {
      var _this10 = this;
      groupList().then(function (_ref) {
        var _this10$groupOptions$;
        var data = _ref.data;
        _this10.groupOptions = data || [];
        var group_id = ((_this10$groupOptions$ = _this10.groupOptions[0]) === null || _this10$groupOptions$ === void 0 ? void 0 : _this10$groupOptions$.id) || '';
        _this10.formData.id = _this10.$route.query.group_id || group_id;
        _this10.groupGetInfo();
      }).catch(function () {
        _this10.groupOptions = [];
        _this10.formData.id = _this10.$route.query.group_id || '';
        _this10.groupGetInfo();
      });
    },
    // 获取组下面列表数据
    groupGetInfo: function groupGetInfo() {
      var _this11 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _yield$groupInfo, data;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this11.formData.grant = [];
              _this11.allSelect.value = false;
              _this11.allSelect.inde = false;
              _this11.handleAllSelect();
              _this11.listCheckArr = listCheckArr(_this11);
              if (!_this11.formData.id) {
                _context3.next = 14;
                break;
              }
              _context3.next = 8;
              return groupInfo({
                group_id: _this11.formData.id
              });
            case 8:
              _yield$groupInfo = _context3.sent;
              data = _yield$groupInfo.data;
              _this11.recouseList.forEach(function (parent) {
                parent.children.forEach(function (sub) {
                  data.grant.forEach(function (item) {
                    if (Number(item.resource_id) === Number(sub.id)) {
                      if (sub.extendLen) {
                        sub.extend_privilege.forEach(function (extend, index) {
                          var key = extend.privilege_key;
                          if (extend.is_can_setting) extend.value = item[key];else extend.value = false;
                        });
                        _this11.handleItemStatus(sub);
                      } else {
                        sub.isSelect.value = true;
                      }
                    }
                  });
                  sub.extend_privilege.forEach(function (extend, index) {
                    var checkItem = _this11.listCheckArr[index] || {};
                    if (extend.is_can_setting) checkItem.data[sub.id] = extend;
                  });
                });
                _this11.handleParentStatus(parent);
              });
              _this11.handleRowStatus();
              _this11.handleAllStatus();
              _this11.formData = data;
            case 14:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    // 删除权限组
    handlerDelete: function handlerDelete() {
      var _this12 = this;
      this.$confirm(this.$t('ask-delete-group'), this.$t('229'), {
        confirmButtonText: this.$t('131'),
        cancelButtonText: this.$t('66'),
        type: 'warning'
      }).then(function () {
        remove({
          group_id: _this12.formData.id
        }).then(function () {
          _this12.handlerBack();
        });
      }).catch(function () {});
    },
    handlerBack: function handlerBack() {
      this.$router.push('/settings/author/authors');
    },
    // 展开 关闭
    handleOpen: function handleOpen(row) {
      row.open = !row.open;
      this.recouseList.forEach(function (item) {
        if (row.id === item.paren_id) item.show = row.open;
      });
    }
  }
};